import { TimelineCard} from "./Cards"
import "./styles/projectsDark.css"
import { timeline } from "../data/timeline"

export default function Timeline() {
  return (
    <div className="pj-page">
        {/* Heading */}
        <div className="pj-header">
          <h1 className="pj-heading">Timeline</h1>
      </div>
      <div className="pj-other-wrap">
          {timeline.toReversed().map((content) => (
            <div key={content.id} className="">
              <TimelineCard 
                logo={content.logo}
                title={content.title}
                details={content.details}
                date={content.date}
                carousel={content.carousel}
                content={content.content}
              />
            </div>
          ))}
        </div>
      </div>
  )
}
